import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#303F9F", // indigo
        secondary: "#9e9e9e", // dark-gray
        accent: "#ffc107", // yellow
        error: "#f44336", // red
        warning: "#f44336", // red
        info: "#2196f3", // green
        success: "#4caf50", // green
        delete: "#ff078f", //pink
      },
    },
  },
});
